import React from 'react';
import { motion } from 'framer-motion';
export function ManifestoSection() {
  return <section className="py-24 lg:py-32 bg-white border-b border-gray-100" data-id="element-316">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-317">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-318">
          <div className="mb-8" data-id="element-319">
            <span className="text-emerald text-xs font-bold tracking-widest uppercase" data-id="element-320">
              Editorial Position
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-10 tracking-tight leading-tight" data-id="element-321">
            Most Credit Advice Ignores How Bureau Reporting Actually Works
          </h2>

          <div className="space-y-8 text-lg text-slate leading-[1.8]" data-id="element-322">
            <p data-id="element-323">
              Traditional credit-repair marketing is built around speed claims,
              outsourced disputes, and vague promises. Consumers pay monthly
              retainers while receiving little visibility into what was
              challenged, how bureaus responded, or whether investigations
              followed federal standards. Most consumers learn this the hard way
              — after months of paying for something that was supposed to be
              working.
            </p>

            <p data-id="element-324">
              Institutional skepticism toward bureau data means treating credit
              reports as financial records that deserve verification, not blind
              trust. The three major bureaus routinely display conflicting
              account histories, inconsistent balances, and mismatched reporting
              timelines across the same consumer file. CFPB complaint records
              show these inconsistencies are not isolated events.
            </p>

            <p data-id="element-325">
              Blinkblis operates as an editorial research and monitoring
              platform, not a credit-repair operation. Every analysis is tied to
              public-source evidence, federal statutes, or documented reporting
              patterns from CFPB complaints, FTC enforcement actions, and FCRA
              litigation records. The goal is simple: help consumers understand
              what they are seeing before they decide how to respond.
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-100" data-id="element-326">
            <p className="text-slate-500 italic text-base" data-id="element-327">
              The framework below explains how experienced consumers approach
              bureau reporting problems systematically — patterns most people
              only notice after they've already been denied.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}